export const CHANGE_IS_MOBILE = 'app/AuthenticatedApp/CHANGE_IS_MOBILE' as const;

export const MOBILE_SIZE = 768 as const;

export const CONTENT_ELEMENT_ID = 'content' as const;
